import domReady from '@wordpress/dom-ready';
import $ from 'jquery';

domReady( function () {
	const root = document.documentElement,
		slick = window.slick,
		sliders = $( '[rel="slider-boxes"]' );
	// const settings = JSON.parse( sliders.attr( 'data-settings' ) );
	const settings = {
		dots: true,
		arrows: true,
		mobileFirst: true,
		appendArrows: $( '.arrows' ),
		appendDots: $( '.arrows' ),
		infinite: false,
		slidesToShow: 2.5,
		slidesToScroll: 1,
		lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 1.5,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2.5,
				},
			},
		],
	};

	sliders.on( 'init', function ( slick ) {
		// console.log( slick.target.slick );
		setTimeout( () => {
			// console.log( slick );
			root.style.setProperty(
				'--slider-box-height',
				`${
					slick.currentTarget.slick.$slideTrack[ 0 ].clientHeight - 40
				}px`
			);
			// root.style.setProperty(
			// 	'--slider-box-width',
			// 	`${ slick.currentTarget.slick.$slides[ 0 ].clientWidth }px`
			// );
		}, 500 );
	} );

	sliders.slick( settings );
} );
